import { ListCard, ListCardTrailingActionCluster } from '@yeshuman/sdk'
import { type ReactNode } from 'react'
import { JobOpeningIdentityHeader, JOB_OPENING_FOOTER_ROW } from '../job-opening-identity'

export type ApplicationListCardProps = {
  opportunityTitle: string
  organisationName: string
  statusRow: ReactNode
  footerMeta: ReactNode
  /** Bottom-trailing actions (e.g. Withdraw); keeps pointer events for nested controls. */
  footerActions?: ReactNode
  onOpen?: () => void
  openAriaLabel?: string
  agentHighlight?: string
  className?: string
}

/** Applied-tab row: job-board identity chrome, status trailing, footer meta + actions. Opens the status canvas. */
export function ApplicationListCard({
  opportunityTitle,
  organisationName,
  statusRow,
  footerMeta,
  footerActions,
  onOpen,
  openAriaLabel,
  agentHighlight,
  className,
}: ApplicationListCardProps) {
  const header = (
    <JobOpeningIdentityHeader
      title={opportunityTitle}
      showPublicationBadge={false}
      organisationLabel={organisationName}
      trailing={
        <div className="pointer-events-none flex shrink-0 flex-wrap items-center justify-end gap-2">
          {statusRow}
        </div>
      }
    />
  )

  const hasFooterActions = footerActions != null
  const footer = (
    <div className={JOB_OPENING_FOOTER_ROW}>
      <div className="min-w-0 flex-1">{footerMeta}</div>
      {hasFooterActions ? (
        <ListCardTrailingActionCluster className="ml-auto">{footerActions}</ListCardTrailingActionCluster>
      ) : null}
    </div>
  )

  return (
    <ListCard
      className={className}
      header={header}
      footer={footer}
      footerClassName="border-t border-border/60"
      onOpen={onOpen}
      openAriaLabel={openAriaLabel ?? `Open application ${opportunityTitle}`}
      agentHighlight={agentHighlight}
    />
  )
}
